import JourneysAllTab from './JourneysAllTabContainer';

export default JourneysAllTab;
